import type { AudioInputDescriptor } from './audioInputs';
import type { EffectStackLayer } from './effectStack';

export interface AudioReactiveStartReadiness {
  enabled: boolean;
  reason: string;
}

/**
 * The one start rule for the Audio reactive card, its panel Start, and the start request. An empty
 * stack would paint black while claiming to run, so it is refused before any controller command.
 */
export function audioReactiveStartReadiness(
  layers: readonly EffectStackLayer[],
  input: AudioInputDescriptor | undefined,
  layoutReady: boolean,
  controlsEnabled: boolean,
): AudioReactiveStartReadiness {
  if (!layers.length) return { enabled: false, reason: 'Add a layer to play.' };
  if (!input?.identity) return { enabled: false, reason: 'Choose an input in Music.' };
  return { enabled: layoutReady && controlsEnabled, reason: '' };
}
